import { render, staticRenderFns } from "./Transport.vue?vue&type=template&id=f28b8c16&scoped=true&"
import script from "./Transport.vue?vue&type=script&lang=js&"
export * from "./Transport.vue?vue&type=script&lang=js&"
import style0 from "./Transport.vue?vue&type=style&index=0&id=f28b8c16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28b8c16",
  null
  
)

export default component.exports